import appboy from '@braze/web-sdk';

let brazeInitialized = false;
const brazeLoadedEvent = new Event('brazeLoaded');

export function initializeBraze(brazeApiKey, brazeBaseUrl, brazeEnableLogging, accountId, nonceScript) {
  if (brazeApiKey && brazeBaseUrl && accountId && nonceScript) {
    appboy.initialize(brazeApiKey, {
      baseUrl: brazeBaseUrl,
      enableLogging: brazeEnableLogging || false,
      allowUserSuppliedJavascript: true,
      contentSecurityNonce: nonceScript.nonce,
    });

    appboy.display.automaticallyShowNewInAppMessages();
    appboy.changeUser(accountId);

    appboy.openSession();

    brazeInitialized = true;
    document.dispatchEvent(brazeLoadedEvent);
  }
  return false;
}

function brazeHasLoaded() {
  if (!brazeInitialized) {
    console.warn('Braze has not been initialized'); // eslint-disable-line no-console
    return false;
  }
  return true;
}

export function sendBrazeEvent(eventName) {
  if (!brazeHasLoaded()) {
    document.addEventListener('brazeLoaded', () => {
      appboy.logCustomEvent(eventName);
    });
  } else {
    appboy.logCustomEvent(eventName);
  }
}
